import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enUS from './locales/en-us.json';
import ptPT from './locales/pt-pt.json';
import esES from './locales/es-es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': {
        translation: enUS
      },
      'en': {
        translation: enUS
      },
      'pt-PT': {
        translation: ptPT
      },
      'pt': {
        translation: ptPT // Default to pt-PT if just pt
      },
      'es-ES': {
        translation: esES
      },
      'es': {
        translation: esES
      }
    },
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
